import React from 'react';
import styled from 'styled-components';
import { SectionProps } from '../../types';

const SectionBase = styled.section`
  padding: ${({ theme }) => theme.spacing['4xl']} 0;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing['3xl']} 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing['2xl']} 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.md};
  }
`;

export const Section: React.FC<SectionProps> = ({
  id,
  className,
  children,
  ...props
}) => {
  return (
    <SectionBase id={id} className={className} {...props}>
      <Container>
        {children}
      </Container>
    </SectionBase>
  );
}; 